import tokens from '@cinch/oxd-utils/tokens/src'

const isTouchAvailable = () => {
  try {
    document.createEvent('TouchEvent')

    return true
  } catch (e) {
    return false
  }
}

export function isMobile(): boolean {
  return window && window.matchMedia && !window.matchMedia(tokens.customMedia.s).matches && isTouchAvailable()
}
